import type { DocMigration } from "../docMigration";

// eslint-disable-next-line @typescript-eslint/naming-convention
const migration_0_0_246: DocMigration = {
  maxSchemaVersion: "0.0.246",
  description: "Update existing kitchen hood props with new origin",
  apply(json: any) {
    const HOOD_30_01_X_ADJUST = 4;
    const HOOD_30_01_Z_ADJUST = 35;

    const HOOD_36_01_X_ADJUST = 4;
    const HOOD_36_01_Z_ADJUST = 35;

    const HOOD_36_01_FLAT_X_ADJUST = 4;
    const HOOD_36_01_FLAT_Y_ADJUST = 0.32;
    const HOOD_36_01_FLAT_Z_ADJUST = 28;

    const hood3001AssetId = 750;
    const hood3601AssetId = 751;
    const hood3601FlatAssetId = 752;

    const hood3001PropTypeIds: string[] = [];
    const hood3601PropTypeIds: string[] = [];
    const hood3601FlatPropTypeIds: string[] = [];

    function adjustOrigin(prop: any, x: number, y: number, z: number) {
      // prop positioning will only be affected by the new prop origin if ORIGIN is used for alignment
      // or alignment is undefined (ORIGIN is the default)
      if (!prop.paramNormalized && (prop.horizontalAlignment === "ORIGIN" || prop.horizontalAlignment === undefined)) {
        prop.param -= x;
      }
      if (y && (prop.lateralAlignment === "ORIGIN" || prop.lateralAlignment === undefined)) {
        prop.lateralOffset === undefined ? (prop.lateralOffset = -y) : (prop.lateralOffset -= y);
      }
      if (z && (prop.verticalAlignment === "ORIGIN" || prop.verticalAlignment === undefined)) {
        prop.verticalOffset === undefined ? (prop.verticalOffset = -z) : (prop.verticalOffset -= z);
      }
    }

    // collect ids of prop catalog items using these props
    for (const settingId in json.settings) {
      const setting = json.settings[settingId];
      if (setting.type === "INTERIOR_PROP_SETTINGS" || setting.type === "EXTERIOR_PROP_SETTINGS") {
        const propTypes = setting.propTypes;
        for (const propTypeId in propTypes) {
          const propType = propTypes[propTypeId];
          if (propType) {
            if (propType.propAssetId === hood3001AssetId) {
              hood3001PropTypeIds.push(propTypeId);
            } else if (propType.propAssetId === hood3601AssetId) {
              hood3601PropTypeIds.push(propTypeId);
            } else if (propType.propAssetId === hood3601FlatAssetId) {
              hood3601FlatPropTypeIds.push(propTypeId);
            }
          }
        }
      }
    }

    // iterate over props and adjust origins
    for (const propId in json.props) {
      const prop = json.props[propId];
      if (hood3001PropTypeIds.includes(prop.propType)) {
        adjustOrigin(prop, HOOD_30_01_X_ADJUST, 0, HOOD_30_01_Z_ADJUST);
      } else if (hood3601PropTypeIds.includes(prop.propType)) {
        adjustOrigin(prop, HOOD_36_01_X_ADJUST, 0, HOOD_36_01_Z_ADJUST);
      } else if (hood3601FlatPropTypeIds.includes(prop.propType)) {
        adjustOrigin(prop, HOOD_36_01_FLAT_X_ADJUST, HOOD_36_01_FLAT_Y_ADJUST, HOOD_36_01_FLAT_Z_ADJUST);
      }
    }

    return json;
  },
};

export default migration_0_0_246;
